import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { AnimatePresence } from "framer-motion";
import "./index.css";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import EnvDebugBanner from './components/common/EnvDebugBanner';
import PasswordChangeWrapper from './components/PasswordChangeWrapper';
import ErrorBoundary from './components/ErrorBoundary';

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <LanguageProvider>
          <QueryClientProvider client={queryClient}>
            <Router>
              <PasswordChangeWrapper>
                <div className="min-h-screen w-full bg-brand-white flex flex-col">
                  <div className="flex-1">
                    <AnimatePresence mode="wait">
                      <AppRoutes />
                    </AnimatePresence>
                  </div>
                  <EnvDebugBanner />
                </div>
              </PasswordChangeWrapper>
            </Router>
          </QueryClientProvider>
        </LanguageProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App; // Cache bust Fri, Sep  5, 2025  4:36:48 PM
